import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useSignUpPage } from '../SignUp/SignUp.hooks';
import { SubscriptionType, SubscriptionTypeValue } from '@app/utils/consts';


export const useWelcomePage = () => {
  const navigate = useNavigate();
  const { submitSignup } = useSignUpPage();
  const [isCreatingAccount, setIsCreatingAccount] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<'starter' | 'professional' | 'enterprise'>('professional');
  const [selectedPlanType, setSelectedPlanType] = useState<SubscriptionTypeValue>(SubscriptionType.PRO);
  const [activeTab, setActiveTab] = useState<'plan' | 'free'>('plan');

  // Check for validateEmail parameter immediately
  const urlParams = new URLSearchParams(window.location.search);
  const validateEmail = urlParams.get('validateEmail');
  const hasProcessedEmailValidation = useRef(false);

  // Handle email validation redirect - just clear URL parameters, don't create account yet
  useEffect(() => {
    if (validateEmail && !hasProcessedEmailValidation.current) {
      hasProcessedEmailValidation.current = true;
      
      // Clear the URL parameters
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('validateEmail');
      window.history.replaceState({}, document.title, newUrl.toString());
    }
  }, [validateEmail]);



  const handleStartPlan = async () => {
    if (isCreatingAccount) return; // Prevent double-clicks
    
    setIsCreatingAccount(true);
    
    try {
      // Retrieve form data from localStorage
      const storedFormData = localStorage.getItem('signupFormData');
      
      if (!storedFormData) {
        console.error('No stored form data found');
        setIsCreatingAccount(false);
        return;
      }
      
      const parsedFormData = JSON.parse(storedFormData);
      const isTrial = activeTab === 'free';

      // Store the selected plan in localStorage for later use
      localStorage.setItem('selectedPlanType', selectedPlanType);
      localStorage.setItem('selectedPlan', selectedPlan);
      
      // If user selected "Start with a plan" and selected paid plan, redirect to payment
      if (!isTrial && selectedPlanType !== SubscriptionType.FREE) {
        // Add a small delay to ensure localStorage is set before navigation
        setTimeout(() => {
          navigate('/payment');
        }, 200);
        setIsCreatingAccount(false);
        return;
      }
      
      // For "Try for free", create the account immediately with BASIC plan
      const formDataWithPlan = {
        ...parsedFormData,
        planName: isTrial ? SubscriptionType.PRO : selectedPlanType, // Default to PRO plan for free trial or selected plan (FREE) for non paid plans
        isTrial: isTrial, // Set isTrial to true for free trial accounts
      };
      await submitSignup(formDataWithPlan);
      
      // Note: Don't clear localStorage here - it's needed for the confirmation page
      // localStorage.removeItem('signupFormData');
      // localStorage.removeItem('selectedPlan');
    } catch (error) {
      console.error('Error creating account:', error);
      setIsCreatingAccount(false);
    }
  };

    return {
    navigate,
    handleStartPlan,
    isCreatingAccount,
    selectedPlan,
    setSelectedPlan,
    activeTab,
    setActiveTab,
    selectedPlanType,
    setSelectedPlanType
  };
};
